// extracted by mini-css-extract-plugin
export var boldText = "_44-4";
export var checkboxContainer = "_44-6";
export var closeIcon = "_44-i";
export var container = "_44-0";
export var drawer = "_44-8";
export var drawerContent = "_44-9";
export var extraSmallText = "_44-5";
export var fulfillmentGroupTable = "_44-e";
export var largeText = "_44-3";
export var loadingSpinnerContainer = "_44-j";
export var mediumText = "_44-2";
export var narrow = "_44-f";
export var notificationLink = "_44-l";
export var packageCheckIconContainer = "_44-7";
export var slideoutHeaderActions = "_44-g";
export var slideoutHeaderActionsShifted = "_44-h";
export var slideoutHeaderContainer = "_44-a";
export var slideoutModal = "_44-c";
export var stickyHeaderWrapper = "_44-b";
export var table = "_44-k";
export var tableContainer = "_44-d";
export var tertiaryText = "_44-1";